import Vue from 'vue'
import axios from 'axios'

const state = {
  limit: 20,
  isFetching: false,
  isFetchingDropdown: false,
  isRequesting: false,
  isMore: true,
  messages: null,
  inboxMessages: []
}

const actions = {
  SET_MESSAGE_READ_DROPDOWN: ({ commit }, message) => {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post('chats/messages/receipt-read', message)
        resolve('success')
      } catch (e) {
        alert(e)
        reject(e)
      }
    })
  },
  LOAD_MESSAGE_INBOX: async ({ commit, rootState }, queryData) => {
    commit('SET_IS_FETCHING_DROPDOWN', true)
    let { data } = await axios.get('chats/inbox-dropdown', {
      params: {
        ...queryData,
        user_id: rootState.auth.user.id
      }
    })
    if (!data.error) {
      commit('SET_INBOX_MESSAGE', data.messages)
    } else {
      console.error('Error Fetch Inbox: ', data.message)
    }
    commit('SET_IS_FETCHING_DROPDOWN', false)
  },
  LOAD_MESSAGE_LIST: ({ commit }, queryData) => {
    commit('REQUEST_MESSAGE_LIST', true)
    Vue.http.get('chats/messages', { params: queryData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          (queryData.page > 0) ? commit('ADD_MESSAGE_LIST', response.messages) : commit('SET_MESSAGE_LIST', response.messages)
        } else {
          commit('SET_NO_DATA')
          if (queryData.page === 0) {
            commit('SET_MESSAGE_LIST', [])
          }
        }
      })
  },
  ADD_MESSAGE: ({ commit }, submitData) => {
    commit('REQUEST_MESSAGE_DATA')
    const url = 'chats/messages/text'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('FINISH_REQUEST_MESSAGE_DATA')
        if (!response.error) {
          const newMessage = {
            id: response.message.message_id,
            chat_room_id: response.message.chat_room_id,
            sender_id: response.message.sender_id,
            message: response.message.message,
            image_sm: null,
            image_xl: null,
            message_type_id: 1,
            create_date: response.message.create_date,
            sender_type: 'user',
            is_read: 0
          }
          commit('ADD_NEW_MESSAGE_LIST', newMessage)
        } else {
          alert(response.message)
        }
      })
  }
}

const mutations = {
  SET_IS_FETCHING_DROPDOWN: (state, data) => {
    state.isFetchingDropdown = data
  },
  SET_INBOX_MESSAGE: (state, data) => {
    state.inboxMessages = data
  },
  REQUEST_MESSAGE_LIST: (state, data) => {
    state.isFetching = data
  },
  REQUEST_MESSAGE_DATA: (state) => {
    state.isRequesting = true
  },
  FINISH_REQUEST_MESSAGE_DATA: (state) => {
    state.isRequesting = false
  },
  SET_NO_DATA: (state) => {
    state.isMore = false
  },
  SET_MESSAGE_LIST: (state, messages) => {
    state.messages = messages
    state.isFetching = false
    state.isMore = true
    if (messages.length < state.limit) {
      state.isMore = false
    }
  },
  ADD_MESSAGE_LIST: (state, messages) => {
    state.isFetching = false
    state.isMore = true
    for (let key in messages) {
      state.messages.push(messages[key])
    }
    if (messages.length < state.limit) {
      state.isMore = false
    }
  },
  ADD_NEW_MESSAGE_LIST: (state, message) => {
    state.messages.unshift(message)
  },
  SET_EMPTY_MESSAGE_LIST: (state) => {
    state.messages = null
  }
}

const getters = {
  getState: state => {
    return state
  },
  isLoadMore: state => {
    return state.isFetching ? 'message.button.loading' : 'message.button.load_more_messages'
  },
  isSendingMessage: state => {
    return state.isRequesting ? 'message.button.sending' : 'message.button.send_message'
  },
  getMessages: state => {
    return state.messages
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/message.js